import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConsultationsCardProps } from '../components/ConsultationsCard';

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer';
import { getConsultations, selectConsultations } from '@/redux/reducers/consultation.reducer';
import LocalConsultationsCard, { LocalConsultationData } from '../components/LocalConsultationsCard';
import { ConsultationType } from '@/core/models/consultation.model';
import StartLocalConsultationDialog from './StartLocalConsultationDialog';

export function LocalConsultationCardContainer(props: Pick<ConsultationsCardProps, 'sx'>) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const consultations = useAppSelector(selectConsultations);

  const consultationsData: LocalConsultationData[] = useMemo(() => {
    return _.map(consultations, (consultation) => ({
      id: consultation._id,
      name: consultation.patient?.userInfo.name || '',
      surname: consultation.patient?.userInfo.surname || '',
      gender: consultation.patient?.userInfo.gender || 'M',
      startDate: consultation.startDate,
      type: consultation.type,
      status: consultation.status,
    }));
  }, [consultations]);

  useEffect(() => {
    dispatch(
      getConsultations(
        {
          type: ConsultationType.Local,
        },
        {
          limit: 10,
          order: 'DESC',
          orderBy: 'startDate',
        }
      )
    );
  }, [dispatch]);

  const [createLocalConsultation, setCreateLocalConsultation] = useState(false);

  return (
    <>
      <LocalConsultationsCard
        {...props}
        consultations={consultationsData}
        emptyMessage={t('page.home.consultations.noConsultationMessage', { context: 'today' })}
        sx={{ boxShadow: 'none' }}
        onCreateConsultation={() => setCreateLocalConsultation(true)}
      />
      {createLocalConsultation && (
        <StartLocalConsultationDialog
          open={createLocalConsultation}
          onClose={() => setCreateLocalConsultation(false)}
        />
      )}
    </>
  );
}

export default LocalConsultationCardContainer;